// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Badge } from '@mantine/core';

const DEFAULT_STATUS_COLORS: Record<string, string> = {
  active: 'green',
  inactive: 'gray',
  terminated: 'red',
  pending: 'yellow',
  approved: 'green',
  denied: 'red',
  rejected: 'red',
  completed: 'blue',
  failed: 'red',
  draft: 'gray',
  processing: 'cyan',
  on_leave: 'orange',
  open: 'green',
  locked: 'yellow',
  closed: 'gray',
  cancelled: 'gray',
  submitted: 'blue',
  in_progress: 'cyan',
  warning: 'orange',
  critical: 'red',
  voided: 'gray',
};

interface StatusBadgeProps {
  status: string;
  colorMap?: Record<string, string>;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function StatusBadge({
  status,
  colorMap,
  size = 'sm',
}: StatusBadgeProps) {
  const normalizedStatus = status.toLowerCase().replace(/\s+/g, '_');
  const mergedColors = colorMap
    ? { ...DEFAULT_STATUS_COLORS, ...colorMap }
    : DEFAULT_STATUS_COLORS;
  const color = mergedColors[normalizedStatus] || 'gray';
  const label = status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <Badge color={color} variant="light" size={size}>
      {label}
    </Badge>
  );
}
